// extracted by mini-css-extract-plugin
module.exports = {"centerHeading":"CenterHeading_centerHeading__iNsWL","spacing":"CenterHeading_spacing__F1C1d"};